<template>
  <div class="row justify-content-center">
    <div class="col-md-11">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">
            {{ $route.params.id ? "Editar" : "Nova" }} Pergunta do Questionário
          </h4>

          <div class="row">
            <div class="col-md-8">
              <div class="row">
                <div class="col-md-12">
                  <label>Pergunta exibida no totem</label>
                  <input
                    type="text"
                    class="form-control"
                    maxlength="120"
                    v-model="pergunta.enunciado"
                    placeholder="O que você está sentindo?"
                  />
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-md-4">
                  <label>Respostas permitidas</label>
                  <select class="form-control" v-model="pergunta.selecao">
                    <option value="multipla">Várias respostas</option>
                    <option value="unica">Uma resposta</option>
                  </select>
                </div>
                <div class="col-md-3">
                  <label>Ordem</label>
                  <input
                    type="number"
                    min="0"
                    class="form-control"
                    v-model="pergunta.ordem"
                  />
                </div>
                <div class="col-md-5">
                  <br />
                  <div class="custom-control custom-switch mb-2">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="perguntaObrigatoria"
                      v-model="pergunta.obrigatoria"
                    />
                    <label class="custom-control-label" for="perguntaObrigatoria">
                      Resposta obrigatória
                    </label>
                  </div>
                  <div class="custom-control custom-switch mb-2">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="perguntaAtiva"
                      v-model="pergunta.ativo"
                    />
                    <label class="custom-control-label" for="perguntaAtiva">
                      Ativa
                    </label>
                  </div>
                  <div class="custom-control custom-switch" v-if="temLinhaCuidado">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="perguntaUsaGrupos"
                      v-model="pergunta.usa_grupos"
                    />
                    <label class="custom-control-label" for="perguntaUsaGrupos">
                      Agrupar respostas
                    </label>
                  </div>
                </div>
              </div>

              <div class="row mt-4" v-if="temLinhaCuidado && pergunta.usa_grupos">
                <div class="col-md-12 d-flex justify-content-between align-items-center">
                  <label class="mb-0">Grupos de respostas</label>
                  <button class="btn btn-sm btn-add" @click="adicionaGrupo">
                    <i class="fa fa-plus"></i> Adicionar grupo
                  </button>
                </div>
                <div class="col-md-12 mt-2">
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th width="20%">Nome do grupo</th>
                        <th width="34%">Respostas deste grupo</th>
                        <th width="22%">Linha de cuidado sugerida</th>
                        <th width="16%">Respostas necessárias</th>
                        <th width="8%"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(grupo, posicao) in pergunta.grupos" :key="posicao">
                        <td>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            maxlength="120"
                            v-model="grupo.nome"
                            placeholder="Respiratório"
                          />
                        </td>
                        <td>
                          <v-select
                            :options="alternativasParaGrupo"
                            :reduce="(item) => item.posicao"
                            label="nome"
                            multiple
                            v-model="grupo.alternativas_posicoes"
                            class="vselect"
                            placeholder="Selecione as respostas..."
                            @input="garanteRespostaEmUmGrupo(posicao)"
                          ></v-select>
                        </td>
                        <td>
                          <select
                            class="form-control form-control-sm"
                            v-model="grupo.linha_cuidado_id"
                          >
                            <option :value="null">Nenhuma</option>
                            <option
                              v-for="linha in linhasCuidado"
                              :key="linha.id"
                              :value="linha.id"
                            >
                              {{ linha.nome }}
                            </option>
                          </select>
                        </td>
                        <td>
                          <input
                            type="number"
                            min="1"
                            :max="grupo.alternativas_posicoes.length || 1"
                            class="form-control form-control-sm"
                            :class="{ 'is-invalid': avisoDoGrupo(grupo) }"
                            v-model="grupo.minimo_respostas"
                          />
                          <small class="text-danger" v-if="avisoDoGrupo(grupo)">
                            {{ avisoDoGrupo(grupo) }}
                          </small>
                        </td>
                        <td class="text-center">
                          <button
                            class="btn btn-sm btn-outline-danger"
                            @click="removeGrupo(posicao)"
                            title="Remover grupo"
                          >
                            <i class="fa fa-times"></i>
                          </button>
                        </td>
                      </tr>
                      <tr v-if="!pergunta.grupos.length">
                        <td colspan="5" class="text-center text-muted">
                          Nenhum grupo. Crie um grupo e indique quantas respostas dele são
                          necessárias para sugerir a linha de cuidado.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="row mt-4">
                <div class="col-md-12 d-flex justify-content-between align-items-center">
                  <label class="mb-0">Alternativas</label>
                  <button class="btn btn-sm btn-add" @click="adicionaAlternativa">
                    <i class="fa fa-plus"></i> Adicionar alternativa
                  </button>
                </div>
                <div class="col-md-12 mt-2">
                  <table class="table table-sm">
                    <thead>
                      <tr>
                        <th width="26%">Texto</th>
                        <th width="10%">Ordem</th>
                        <th width="22%">Ícone</th>
                        <th width="26%" v-if="temLinhaCuidado && !pergunta.usa_grupos">
                          Linha de cuidado sugerida
                        </th>
                        <th width="8%">Ativa</th>
                        <th width="8%"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(alternativa, indice) in pergunta.alternativas"
                        :key="indice"
                      >
                        <td>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            maxlength="120"
                            v-model="alternativa.nome"
                            placeholder="Febre"
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            min="0"
                            class="form-control form-control-sm"
                            v-model="alternativa.ordem"
                          />
                        </td>
                        <td>
                          <div class="d-flex align-items-center">
                            <img
                              v-if="alternativa.icone_preview"
                              :src="alternativa.icone_preview"
                              height="28"
                              class="mr-2"
                            />
                            <input
                              type="file"
                              class="form-control-file"
                              :id="'alternativa_icone_' + indice"
                              accept=".svg,.png,.jpg,.jpeg,.webp"
                              @change="selecionaIcone(indice, $event)"
                            />
                            <button
                              v-if="alternativa.icone_preview"
                              class="btn btn-sm btn-outline-danger ml-1"
                              @click="removeIcone(indice)"
                              title="Remover ícone"
                            >
                              <i class="fa fa-trash"></i>
                            </button>
                          </div>
                        </td>
                        <td v-if="temLinhaCuidado && !pergunta.usa_grupos">
                          <select
                            class="form-control form-control-sm"
                            v-model="alternativa.linha_cuidado_id"
                          >
                            <option :value="null">Nenhuma</option>
                            <option
                              v-for="linha in linhasCuidado"
                              :key="linha.id"
                              :value="linha.id"
                            >
                              {{ linha.nome }}
                            </option>
                          </select>
                        </td>
                        <td class="text-center">
                          <div class="custom-control custom-switch">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              :id="'alternativa_ativa_' + indice"
                              v-model="alternativa.ativo"
                              @change="tiraInativaDosGrupos(indice)"
                            />
                            <label
                              class="custom-control-label"
                              :for="'alternativa_ativa_' + indice"
                            ></label>
                          </div>
                        </td>
                        <td class="text-center">
                          <button
                            class="btn btn-sm btn-outline-danger"
                            @click="removeAlternativa(indice)"
                            title="Remover alternativa"
                          >
                            <i class="fa fa-times"></i>
                          </button>
                        </td>
                      </tr>
                      <tr v-if="!pergunta.alternativas.length">
                        <td
                          :colspan="temLinhaCuidado && !pergunta.usa_grupos ? 6 : 5"
                          class="text-center text-muted"
                        >
                          Nenhuma alternativa. Sem alternativas a pergunta não aparece no
                          totem.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-md-12">
                  <label>Demandas que fazem esta pergunta</label>
                  <v-select
                    :options="botoes"
                    :reduce="(botao) => botao.id"
                    :label="'nome'"
                    multiple
                    v-model="pergunta.botoes_selecionados"
                    class="vselect"
                    placeholder="Selecione as demandas..."
                  ></v-select>
                  <small class="text-muted">
                    O mesmo vínculo aparece no cadastro da demanda. É ele que faz o totem
                    perguntar: demanda sem pergunta nenhuma abre a senha direto.
                  </small>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <label>Pré-visualização no totem</label>
              <div class="preview-totem p-3">
                <div class="preview-titulo mb-3">
                  {{ pergunta.enunciado || "Pergunta exibida no totem" }}
                </div>
                <div class="d-flex flex-wrap justify-content-center">
                  <div
                    class="preview-card"
                    :class="{ 'preview-card-selecionado': indice === 0 }"
                    v-for="(alternativa, indice) in alternativasVisiveis"
                    :key="indice"
                  >
                    <img
                      v-if="alternativa.icone_preview"
                      :src="alternativa.icone_preview"
                      height="34"
                      class="mb-2"
                    />
                    <span>{{ alternativa.nome || "Alternativa" }}</span>
                  </div>
                </div>
                <div class="preview-legenda mt-3">
                  {{
                    pergunta.selecao === "unica"
                      ? "Uma resposta"
                      : "Várias respostas"
                  }}
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-md-12 text-right">
              <hr />
              <button
                class="btn btn-back mr-1"
                @click="$router.push('/questionario_perguntas')"
              >
                <i class="fa fa-arrow-left"></i> Voltar
              </button>
              <button class="btn btn-add" @click="save">
                Salvar <i class="fa fa-save"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  components: { vSelect },
  data() {
    return {
      pergunta: {
        enunciado: "",
        selecao: "multipla",
        usa_grupos: false,
        obrigatoria: true,
        ativo: true,
        ordem: 0,
        alternativas: [],
        grupos: [],
        botoes_selecionados: [],
      },
      botoes: [],
      linhasCuidado: [],
    };
  },
  computed: {
    temLinhaCuidado() {
      return this.linhasCuidado.length > 0;
    },
    alternativasParaGrupo() {
      return this.pergunta.alternativas
        .map((alternativa, posicao) => ({
          posicao: posicao,
          nome: alternativa.nome || "Alternativa " + (posicao + 1),
          ativo: alternativa.ativo,
        }))
        .filter((alternativa) => alternativa.ativo);
    },
    alternativasVisiveis() {
      return this.pergunta.alternativas.filter(
        (alternativa) => alternativa.ativo !== false
      );
    },
  },
  methods: {
    avisoDoGrupo: function (grupo) {
      const respostas = (grupo.alternativas_posicoes || []).length;
      const minimo = Number(grupo.minimo_respostas) || 0;

      if (!respostas) {
        return "Sem respostas selecionadas: este grupo não vai sugerir nada.";
      }

      if (minimo > respostas) {
        return (
          "O grupo exige " +
          minimo +
          " resposta(s) e só tem " +
          respostas +
          ": nunca vai sugerir."
        );
      }

      if (!grupo.linha_cuidado_id) {
        return "Sem linha de cuidado: este grupo não vai sugerir nada.";
      }

      return "";
    },
    adicionaGrupo: function () {
      const self = this;

      self.pergunta.grupos.push({
        id: null,
        nome: "",
        alternativas_posicoes: [],
        linha_cuidado_id: null,
        minimo_respostas: 2,
        ordem: self.pergunta.grupos.length + 1,
      });
    },
    garanteRespostaEmUmGrupo: function (posicaoDoGrupo) {
      const self = this;
      const escolhidas = self.pergunta.grupos[posicaoDoGrupo].alternativas_posicoes || [];

      self.pergunta.grupos.forEach((grupo, posicao) => {
        if (posicao === posicaoDoGrupo) {
          return;
        }

        self.$set(
          grupo,
          "alternativas_posicoes",
          (grupo.alternativas_posicoes || []).filter(
            (posicaoDaAlternativa) => !escolhidas.includes(posicaoDaAlternativa)
          )
        );
      });
    },
    removeGrupo: function (posicao) {
      this.pergunta.grupos.splice(posicao, 1);
    },
    adicionaAlternativa: function () {
      const self = this;

      self.pergunta.alternativas.push({
        id: null,
        nome: "",
        ordem: self.pergunta.alternativas.length + 1,
        linha_cuidado_id: null,
        ativo: true,
        icone_preview: "",
        icone_removido: false,
      });
    },
    removeAlternativa: function (indice) {
      const self = this;

      self.pergunta.alternativas.splice(indice, 1);
      self.ajustaPosicoesDosGrupos(indice);
    },
    ajustaPosicoesDosGrupos: function (posicaoRemovida) {
      const self = this;

      self.pergunta.grupos.forEach((grupo) => {
        const posicoes = (grupo.alternativas_posicoes || [])
          .filter((posicao) => posicao !== posicaoRemovida)
          .map((posicao) => (posicao > posicaoRemovida ? posicao - 1 : posicao));

        self.$set(grupo, "alternativas_posicoes", posicoes);
      });
    },
    tiraInativaDosGrupos: function (indice) {
      const self = this;

      if (self.pergunta.alternativas[indice].ativo) {
        return;
      }

      self.pergunta.grupos.forEach((grupo) => {
        self.$set(
          grupo,
          "alternativas_posicoes",
          (grupo.alternativas_posicoes || []).filter((posicao) => posicao !== indice)
        );
      });
    },
    selecionaIcone: function (indice, evento) {
      const self = this;
      const arquivo = evento.target.files[0];

      if (!arquivo) {
        return;
      }

      const alternativa = self.pergunta.alternativas[indice];
      alternativa.icone_removido = false;

      const leitor = new FileReader();
      leitor.onload = function (leitura) {
        self.$set(alternativa, "icone_preview", leitura.target.result);
      };
      leitor.readAsDataURL(arquivo);
    },
    removeIcone: function (indice) {
      const self = this;
      const alternativa = self.pergunta.alternativas[indice];

      self.$set(alternativa, "icone_preview", "");
      self.$set(alternativa, "icone_removido", true);

      const campo = document.getElementById("alternativa_icone_" + indice);
      if (campo) {
        campo.value = "";
      }
    },
    getLinhasCuidado: function () {
      const self = this;
      const api = self.$store.state.api + "linha_cuidados?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.linhasCuidado = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getBotoes: function () {
      const self = this;
      const api = self.$store.state.api + "botoes?paginated=false&ativo=1";

      axios
        .get(api)
        .then((response) => {
          self.botoes = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getPergunta: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "questionario_perguntas/" +
        id +
        "?with[]=alternativas&with[]=grupos&with[]=botoes";

      axios
        .get(api)
        .then((response) => {
          const registro = response.data.data[0];

          const alternativasRecebidas = registro.alternativas || [];

          const grupos = (registro.grupos || []).map((grupo) => ({
            id: grupo.id,
            nome: grupo.nome,
            linha_cuidado_id: grupo.linha_cuidado_id || null,
            minimo_respostas: grupo.minimo_respostas,
            ordem: grupo.ordem,
            alternativas_posicoes: alternativasRecebidas
              .map((alternativa, posicao) =>
                alternativa.questionario_grupo_id === grupo.id ? posicao : null
              )
              .filter((posicao) => posicao !== null),
          }));

          self.pergunta = {
            id: registro.id,
            enunciado: registro.enunciado,
            selecao: registro.selecao,
            usa_grupos: !!registro.usa_grupos,
            grupos: grupos,
            obrigatoria: !!registro.obrigatoria,
            ativo: !!registro.ativo,
            ordem: registro.ordem,
            alternativas: alternativasRecebidas.map((alternativa) => ({
              id: alternativa.id,
              nome: alternativa.nome,
              ordem: alternativa.ordem,
              linha_cuidado_id: alternativa.linha_cuidado_id || null,
              ativo: !!alternativa.ativo,
              icone_preview: alternativa.icone_url || "",
              icone_removido: false,
            })),
            botoes_selecionados: (registro.botoes || []).map((botao) => botao.id),
          };
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    grupoDaAlternativa: function (posicaoDaAlternativa) {
      const self = this;
      const grupos = self.pergunta.grupos.filter((grupo) => grupo.nome);
      const posicao = grupos.findIndex((grupo) =>
        (grupo.alternativas_posicoes || []).includes(posicaoDaAlternativa)
      );

      return posicao === -1 ? null : posicao;
    },
    montaGrupos: function () {
      const self = this;

      if (!self.pergunta.usa_grupos) {
        return [];
      }

      return self.pergunta.grupos
        .filter((grupo) => grupo.nome)
        .map((grupo, posicao) => ({
          id: grupo.id,
          nome: grupo.nome,
          linha_cuidado_id: grupo.linha_cuidado_id || null,
          minimo_respostas: grupo.minimo_respostas || 1,
          ordem: posicao + 1,
        }));
    },
    makeFormData: function () {
      const self = this;
      const fd = new FormData();

      fd.append("enunciado", self.pergunta.enunciado || "");
      fd.append("selecao", self.pergunta.selecao || "multipla");
      fd.append("obrigatoria", self.pergunta.obrigatoria ? 1 : 0);
      fd.append("ativo", self.pergunta.ativo ? 1 : 0);
      fd.append("ordem", self.pergunta.ordem || 0);
      fd.append("usa_grupos", self.pergunta.usa_grupos ? 1 : 0);
      fd.append("grupos", JSON.stringify(self.montaGrupos()));

      const alternativas = self.pergunta.alternativas.map((alternativa, indice) => {
        const campo = document.getElementById("alternativa_icone_" + indice);

        if (campo && campo.files[0]) {
          fd.append("alternativa_icone_" + indice, campo.files[0]);
        }

        return {
          id: alternativa.id,
          nome: alternativa.nome,
          ordem: alternativa.ordem,
          linha_cuidado_id: self.pergunta.usa_grupos
            ? null
            : alternativa.linha_cuidado_id || null,
          grupo_posicao: self.pergunta.usa_grupos
            ? self.grupoDaAlternativa(indice)
            : null,
          ativo: alternativa.ativo ? 1 : 0,
          remover_icone: alternativa.icone_removido ? 1 : 0,
        };
      });

      fd.append("alternativas", JSON.stringify(alternativas));
      fd.append(
        "botoes_selecionados",
        JSON.stringify(self.pergunta.botoes_selecionados || [])
      );

      fd.append("_method", "POST");

      if (self.pergunta.id) {
        fd.append("id", self.pergunta.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "questionario_perguntas";

      if (self.pergunta.id) {
        api += "/" + self.pergunta.id;
      }

      self.$loading(true);

      axios
        .post(api, self.makeFormData())
        .then(() => {
          self.$loading(false);
          self.$message("Sucesso", "Informações guardadas com sucesso", "success");
          self.$router.push("/questionario_perguntas");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    const self = this;

    self.getBotoes();
    self.getLinhasCuidado();

    if (self.$route.params.id) {
      self.getPergunta(self.$route.params.id);
    }
  },
};
</script>

<style scoped>
.preview-totem {
  background: #eeeeee;
  border: 1px solid #d5d5d5;
  border-radius: 6px;
  text-align: center;
}
.preview-titulo {
  color: #0a4d8c;
  font-size: 15px;
  font-weight: 600;
}
.preview-card {
  align-items: center;
  background: #f0f0f0;
  border: 1px solid #0a4d8c;
  border-radius: 4px;
  color: #0a4d8c;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  justify-content: center;
  margin: 3px;
  min-height: 76px;
  padding: 6px;
  width: 84px;
}
.preview-card-selecionado {
  background: #0a4d8c;
  border-color: #0a4d8c;
  color: #ffffff;
}
.preview-legenda {
  color: #777777;
  font-size: 12px;
}
</style>
